var _defs, _rect, _g, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOngoingRevisionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a{fill:rgba(255,255,255,0);}.b,.c{fill:#484848;}.c{stroke:#484848;}.d,.f{fill:none;}.d{stroke:#fff;stroke-linecap:round;}.e{stroke:none;}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-957.265 -732)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 12,
    height: 10,
    rx: 1,
    transform: "translate(970.265 735) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(963.265 733)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 2,
    cy: 2,
    r: 1.5
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 5,
    transform: "translate(5.5 6)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 5,
    transform: "translate(5.5 8)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 5,
    transform: "translate(5.5 10)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingRevisionIcon);
export default __webpack_public_path__ + "static/media/ongoingRevisionIcon.5fe5439544328a40c4c041cb52df1277.svg";
export { ForwardRef as ReactComponent };